import { useParams } from 'react-router-dom'
import { useMutation, useQueryClient } from 'react-query'

import { accountsService } from 'src/services/accounts.service'
import { QUERY_KEYS } from 'src/constants'
import { IAccountManualCreateDto } from 'src/types'

export const useCreateAccountManual = () => {
  const { id } = useParams()
  const queryClient = useQueryClient()

  return useMutation((dto: IAccountManualCreateDto) => accountsService.createAccountManual(dto), {
    onSuccess(data) {
      if (!data) return
      queryClient.invalidateQueries(QUERY_KEYS.ACCOUNTS_ALL_RAW)
      queryClient.invalidateQueries([QUERY_KEYS.STEP_ACCOUNTS_CONNECTION, id])
    },
  })
}
